import * as React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { I18n } from 'react-redux-i18n'
import './styles.scss'
import QRCodeCreatorModal from './QRCodeCreatorModal'
import SelectChannel from './SelectChannel'
import { channels as channelsNewApi } from 'api'
import WebWidgetDisplay from './WebWidgetDisplay'
import Channels from './Channels'
import { toast } from 'react-toastify'
import ModalDelete from 'components/ModalDelete'
import { channelName } from 'constants/channels'
import WebWidgetCreatorModal from './WebWidgetCreatorModal'
import { ChannelsContainers } from './ChannelsContainers'
// import SyncErrorModal from './Channels/ChatMail/AddAccountModals/SyncErrorModal'

const Index = () => {
  const [accountType, setAccountType] = React.useState('corporate')
  const [channels, setChannels] = React.useState([])
  const [isOpenModalAddChannel, setIsOpenModalAddChannel] = React.useState(false)
  const [isOpenModalQR, setIsOpenModalQR] = React.useState(false)
  const [isOpenModalWebWidget, setIsOpenModalWebWidget] = React.useState(false)
  const [isOpenModalWebWidgetDisplay, setIsOpenModalWebWidgetDisplay] = React.useState(false)
  const [webWidgetSelectedChannels, setWebWidgetSelectedChannels] = React.useState([])
  const [webWidgetPrimaryColor, setWebWidgetPrimaryColor] = React.useState('')
  const [webWidgetToken, setWebWidgetToken] = React.useState('')
  const [selectedChannel, setSelectedChannel] = React.useState(null)
  const [activeChannels, setActiveChannels] = React.useState([])
  const [pendingChannels, setPendingChannels] = React.useState([])
  const [, setShowOldChannels] = React.useState('none')
  const [loading, setLoading] = React.useState(true)
  const [isOpenModalChannel, setIsOpenModalChannel] = React.useState(false)
  const [isOpenModalDelete, setIsOpenModalDelete] = React.useState(false)
  const [removing, setRemoving] = React.useState(false)
  const { location, push } = useHistory()
  const { id } = useParams()
  const history = useHistory()
  const [webWidget, setWebWidget] = React.useState(null)
  const [webWidgetIsNew, setWebWidgetIsNew] = React.useState(false)
  const [dataQRPosterCloneWebWidget, setDataQRPosterCloneWebWidget] = React.useState(null)
  const [dataWebWidgetCloneQRPoster, setDataWebWidgetCloneQRPoster] = React.useState(null)

  React.useEffect(() => {
    if (!loading) {
      try {
        const data = new URLSearchParams(history.location.search)
        const channelToOpen = data.get('c')
        if (channelToOpen) onChangeSelectedChannel({ hub: channelName[channelToOpen].hub, key: channelToOpen })
      } catch (error) {
        console.error(error)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  React.useEffect(() => {
    if (id && channels) {
      setSelectedChannel(channels.filter(channel => channel._id === id)[0])

      if (selectedChannel) setIsOpenModalChannel(true)
    } else {
      if (selectedChannel) {
        if (selectedChannel.toRemove) setIsOpenModalDelete(true)

        if (selectedChannel._id === '0') {
          setIsOpenModalChannel(true)
        } else {
          setIsOpenModalChannel(false)
        }
      }
    }
  }, [id, channels, selectedChannel])

  React.useEffect(() => {
    if (!removing) {
      setIsOpenModalDelete(false)
      setSelectedChannel(null)
    }
  }, [removing])

  React.useEffect(() => {
    if (!channels.length) {
      getChannels()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const onDataQRToWidget = React.useCallback((data) => {
    setDataQRPosterCloneWebWidget(data)
    setIsOpenModalQR(false)
    setIsOpenModalWebWidget(true)
  }, [])

  const onDataWidgetToQR = React.useCallback((data) => {
    setDataWebWidgetCloneQRPoster(data)
    setIsOpenModalWebWidget(false)
    setIsOpenModalQR(true)
  }, [])

  const getChannels = () => {
    channelsNewApi.getList()
      .then(({ data }) => {
        setLoading(false)
        setChannels(data)
        setChannelsActiveAndPending(data)
        if (data.length > 0)
          setShowOldChannels('block')
      })
      .catch(console.error)
  }

  const setChannelsActiveAndPending = (_channels) => {
    const { _activeChannels, _pendingChannels } = _channels.reduce(
      (preV, next) => {
        switch (next.state) {
          case 'PENDING':
          case 'REQUESTED':
          case 'IN_PROGRESS':
            preV._pendingChannels.push(next)
            break
          default:
            preV._activeChannels.push(next)
            break
        }
        return preV
      },
      { _activeChannels: [], _pendingChannels: [] }
    )
    setActiveChannels(_activeChannels)
    setPendingChannels(_pendingChannels)
  }

  const goToDisplay = () => {
    setIsOpenModalWebWidget(false)
    setIsOpenModalWebWidgetDisplay(true)
  }

  const createWebWidget = (config, selectedChannels, token, isNew) => {
    setWebWidgetPrimaryColor(config.primaryColor)
    setWebWidgetSelectedChannels(selectedChannels)
    setWebWidgetToken(token)
    setWebWidget(config)
    setWebWidgetIsNew(isNew)
    goToDisplay()
  }

  const onChangeSelectedChannel = (channel) => {
    setSelectedChannel({ ...channel, _id: '0' })

    setTimeout(() => {
      onCloseSelectedChannel()
    }, 500)
  }
  const onCloseSelectedChannel = (value) => {
    if (!value && channels.length === 0) {
      setShowOldChannels('none')
    }
    setIsOpenModalAddChannel(false)
  }

  const onEdit = (channel) => {
    push(`${location.pathname}/${channel._id}`)
  }

  const onDeleteModal = (channel) => {
    setSelectedChannel({ ...channel, toRemove: true })
  }

  const onDelete = async () => {
    if (selectedChannel.isNew) return

    setRemoving(true)

    let msg = ''
    try {
      const { data } = await channelsNewApi.deleteById(selectedChannel._id)

      if (data.success) {
        getChannels()
        msg = 'toasts_channel_deleted'
      } else {
        msg = data.type || 'toasts_channel_error_delete'
      }
    } catch (error) {
      msg = 'toasts_channel_error_delete'
    }

    toast(I18n.t(msg), { position: 'top-center' })

    setRemoving(false)
  }

  return (
    <div className='animated fadeIn channels-configuration'>
      <ChannelsContainers
        accountType={accountType}
        setAccountType={setAccountType}
        containersData={{
          corporate: {
            name: 'dashboard_corporate-channels',
            data: {
              activeChannels,
              setIsOpenModalQR,
              setIsOpenModalWebWidget,
              loading,
              channels,
              getChannels,
              pendingChannels,
              onEdit,
              onDeleteModal,
              setIsOpenModalAddChannel
            }
          },
          // personal: {
          //   name: 'dashboard_personal-channels',
          //   data: {
          //     activeChannels,
          //     setIsOpenModalQR,
          //     setIsOpenModalWebWidget,
          //     loading,
          //     channels,
          //     getChannels,
          //     pendingChannels,
          //     onEdit,
          //     onDeleteModal,
          //     setIsOpenModalAddChannel
          //   }
          // }
        }}
      />
      {isOpenModalAddChannel &&
        <SelectChannel
          isOpen={isOpenModalAddChannel}
          toggle={() => onCloseSelectedChannel(null)}
          selectedChannel={(channel) => onChangeSelectedChannel(channel)}
        />
      }
      {(isOpenModalChannel && selectedChannel) &&
        <Channels
          isOpen={isOpenModalChannel}
          toggle={() => { setIsOpenModalChannel(!isOpenModalChannel); if (id) { push(location.pathname.split(`/${id}`)[0]) } }}
          channel={{ _id: selectedChannel._id || null, key: selectedChannel.key, hub: selectedChannel.hub }}
          getChannels={getChannels}
          accountType={accountType}
        />
      }
      <QRCodeCreatorModal
        isOpen={isOpenModalQR}
        onClose={() => {
          setIsOpenModalQR(!isOpenModalQR)
          setDataWebWidgetCloneQRPoster(null)
        }}
        channels={activeChannels.filter(it => (it.key !== 'wall' || !it.value.connectionType || (it.key === 'wall' && it.value.connectionType !== 'chatweb_api')))}
        onDataQRToWidget={onDataQRToWidget}
        dataCloneWebWidgetToQr={dataWebWidgetCloneQRPoster}
      />
      <WebWidgetCreatorModal
        isOpen={isOpenModalWebWidget}
        onClose={() => {
          setIsOpenModalWebWidget(!isOpenModalWebWidget)
          setDataQRPosterCloneWebWidget(null)
        }}
        channels={activeChannels.filter(it => (it.key !== 'wall' || !it.value.connectionType || (it.key === 'wall' && it.value.connectionType !== 'chatweb_api')))}
        createWebWidget={createWebWidget}
        onDataWidgetToQR={onDataWidgetToQR}
        dataCloneQrToWebWidget={dataQRPosterCloneWebWidget}
      />
      <WebWidgetDisplay
        isOpen={isOpenModalWebWidgetDisplay}
        toggle={() => { setIsOpenModalWebWidgetDisplay(!isOpenModalWebWidgetDisplay); setWebWidgetIsNew(false) }}
        selectedChannels={webWidgetSelectedChannels}
        primaryColor={webWidgetPrimaryColor}
        webWidgetToken={webWidgetToken}
        widget={webWidget}
        isNew={webWidgetIsNew}
        setIsOpenModalWebWidget={setIsOpenModalWebWidget}
      />
      {isOpenModalDelete && (
        <ModalDelete
          isOpen={isOpenModalDelete}
          toggle={() => setIsOpenModalDelete(!isOpenModalDelete)}
          header={I18n.t('dashboard_delete-channel')}
          text1={I18n.t('dashboard_sure-want-delete-channel')}
          text2={I18n.t('channels_remove_channel_legend')}
          event={onDelete}
          isSubmitting={removing}
        />
      )}
      {/* <SyncErrorModal
        isOpen={isOpenSyncErrorModal}
        toggle={()=>setIsOpenSyncErrorModal(!isOpenSyncErrorModal)}
        onClick={(channelId) => history.push(`${history.location.pathname}/${channelId}`)}
      /> */}
    </div>
  )
}

export default Index
